import { useMemo, useState } from 'react'
import { EuiButton, EuiPopover } from '@equipmentshare/ds2'
import { PartsOrderedDetail } from '../../../../../graphql'
import OrderedTable from '../OrderedTable'

export type OrderedPopoverProps = {
  partsOrdered: PartsOrderedDetail[],
}

export default function OrderedPopover( { partsOrdered }: OrderedPopoverProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )
	const quantity = useMemo( () => partsOrdered.reduce( ( total, order ) => total + order.quantityOrdered, 0 ), [ partsOrdered ] )

	if ( quantity === 0 ) {
		return null
	}

	const button = (
		<EuiButton
			color="text"
			onClick={() => setIsPopoverOpen( !isPopoverOpen )}
			size="s"
		>
			{quantity} {quantity === 1 ? 'item' : 'items'}
		</EuiButton>
	)

	return (
		<EuiPopover
			button={button}
			isOpen={isPopoverOpen}
			closePopover={() => setIsPopoverOpen( false )}
		>
			<OrderedTable
				orders={partsOrdered}
			/>
		</EuiPopover>
	)
}
